import React from "react";
import { useForm } from "react-final-form";

var selected;

export const PositionGrid = React.memo((props)=>{
    const form = useForm();
    var canvas = document.getElementById("canvas1");
    var contenedor = document.getElementById("Contenedor");
    var cuadritos = [];
    var sizeCuadro = { ancho: 25, alto: 25 };
    var color = "";
    var inputColor = {value:"#007eec"};
    const alphabet = [0,"A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

    if (canvas && canvas.getContext) {
        var ctx = canvas.getContext("2d");
        var init = false;
        if (ctx) {
            function dibujaGrid(disX, disY, anchoLinea, color) {
                ctx.strokeStyle = color;
                ctx.lineWidth = anchoLinea;
                if(canvas.width !== 250 || canvas.height !== 250){
                    canvas.width = 250;
                    canvas.height = 250;
                }
                var columnas = [];
                var filas = [];
                columnas.push(0);
                filas.push(0);
                for (let i = disX; i < canvas.width; i += disX) {
                    ctx.beginPath();
                    ctx.moveTo(i, 25);
                    ctx.lineTo(i, canvas.height);
                    ctx.stroke();
                    columnas.push(i);
                    if(!init){
                        ctx.strokeText(" " + alphabet[i/25],i+5,15)
                    }
                }
                for (let i = disY; i < canvas.height; i += disY) {
                    ctx.beginPath();
                    ctx.moveTo(25, i);
                    ctx.lineTo(ctx.canvas.width, i);
                    ctx.stroke();
                    filas.push(i);
                    if(!init){
                        ctx.strokeText(" " + i/25,5,i+15)
                    }
                }
                for (let x = 0; x < columnas.length; x++) {
                    for (let y = 0; y < filas.length; y++) {
                        cuadritos.push([columnas[x], filas[y], disX, disY, alphabet[x],y]);
                    }
                }
                init = true;
            }

            function fillCell(x, y) {
                for (let i = 0; i < cuadritos.length; i++) {
                    var cuadro = cuadritos[i];
                    if (
                        x > cuadro[0] &&
                        x < cuadro[0] + cuadro[2] &&
                        y > cuadro[1] &&
                        y < cuadro[1] + cuadro[3] &&
                        cuadro[4]!==0 &&
                        cuadro[5]!==0
                    ) {
                        if(selected){
                            ctx.fillStyle = "white";
                            ctx.fillRect(
                                selected[0]+2,
                                selected[1]+2,
                                sizeCuadro.ancho-4,
                                sizeCuadro.alto-4
                            );
                        }
                        selected = cuadro;
                        color = inputColor.value;
                        ctx.fillStyle = color;
                        ctx.fillRect(
                            cuadro[0]+2,
                            cuadro[1]+2,
                            sizeCuadro.ancho-4,
                            sizeCuadro.alto-4
                        );
                        dibujaGrid(sizeCuadro.ancho, sizeCuadro.alto, 0.4, "#44414B");
                        break;
                    }
                }
                form.change("isolates_storages.cryobox_position",selected[4]+selected[5]);
            }

            canvas.onclick = function (e) {
                var canvaspos = canvas.getBoundingClientRect();
                fillCell(e.clientX - canvaspos.left, e.clientY - canvaspos.top);
            };

            canvas.width = contenedor.offsetWidth - 400;
            dibujaGrid(sizeCuadro.ancho, sizeCuadro.alto, 1, "#44414B");
        } else {
            alert("No se pudo cargar el contexto");
        }
    }

    return (
        <div id="Contenedor" >
            <div id="contenedorCanvas">
                <canvas id="canvas1" width="250" height="250">
                    Tu navegador no soporta canvas
                </canvas>
            </div>
        </div>
    )
}
);